import type { Maybe } from 'src/lib/types';

import {
  AD_ASSET_TYPE,
  type AdAssetType,
  ASSET_TYPE,
  type AssetType,
  BLOG_POST_ASSET_TYPE,
  type BlogPostAssetType,
  CANVAS_ASSET_TYPE,
  type CanvasAssetType,
  EMAIL_ASSET_TYPE,
  type EmailAssetType,
  IMAGE_ASSET_TYPE,
  type ImageAssetType,
  LANDING_ASSET_TYPE,
  type LandingAssetType,
  PRODUCT_LISTING_ASSET_TYPE,
  type ProductListingAssetType,
  SMS_ASSET_TYPE,
  type SmsAssetType,
} from './const';

export const isAdAssetType = (type: Maybe<string>): type is AdAssetType =>
  Object.values(AD_ASSET_TYPE).includes(type as AdAssetType);

export const isLandingAssetType = (type: Maybe<string>): type is LandingAssetType =>
  Object.values(LANDING_ASSET_TYPE).includes(type as LandingAssetType);

export const isEmailAssetType = (type: Maybe<string>): type is EmailAssetType =>
  Object.values(EMAIL_ASSET_TYPE).includes(type as EmailAssetType);

export const isBlogPostAssetType = (type: Maybe<string>): type is BlogPostAssetType =>
  Object.values(BLOG_POST_ASSET_TYPE).includes(type as BlogPostAssetType);

export const isSmsAssetType = (type: Maybe<string>): type is SmsAssetType =>
  Object.values(SMS_ASSET_TYPE).includes(type as SmsAssetType);

export const isCanvasAssetType = (type: Maybe<string>): type is CanvasAssetType =>
  Object.values(CANVAS_ASSET_TYPE).includes(type as CanvasAssetType);

export const isProductListingAssetType = (type: Maybe<string>): type is ProductListingAssetType =>
  Object.values(PRODUCT_LISTING_ASSET_TYPE).includes(type as ProductListingAssetType);

export const isFreestyleAssetType = (type: Maybe<string>): type is CanvasAssetType =>
  type === CANVAS_ASSET_TYPE.canvasFreestyle;

export const isImageAssetType = (type: Maybe<string>): type is ImageAssetType =>
  Object.values(IMAGE_ASSET_TYPE).includes(type as ImageAssetType);

export const isAssetType = (type: Maybe<string>): type is AssetType =>
  Object.values(ASSET_TYPE).includes(type as AssetType);

export const assetTypeResemblesHeadline = (type: string): boolean => {
  const parts = ['headline', 'header', 'title'];
  return parts.some((part) => type.toLowerCase().includes(part));
};
